import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { User } from '../shared/models/user.model';
import { ee, departments, sites } from '../shared/constants';
import { setClassInvalidTpl } from '../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  standalone: false
})
export class AccountComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  toast = inject(ToastComponent);
  private userService = inject(UserService);


  user: User;
  emailNotifications = {
    comments: false,
    records: false,
  };
  isLoading = true;
  setClassInvalidTpl = setClassInvalidTpl;
  departments = departments;
  sites = sites;
  currentContent = 'account';
  menuItems = [
    { name: 'Account settings', link: 'account', icon: 'user' },
  ];

  ngOnInit(): void {
    this.getUser();
    ee.on('changeContent', (data: string) => this.currentContent = data);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
  }

  getUser(): void {
    this.userService.get(this.auth.currentUser._id)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: res => {
          this.user = res;
          this.emailNotifications.comments = this.user.emailNotifications.includes('comments');
          this.emailNotifications.records = this.user.emailNotifications.includes('records');
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  generateEmailNotificationsArray() {
    const newEmailNotifications = [];
    for (const key in this.emailNotifications) {
      if (this.emailNotifications[key]) {
        newEmailNotifications.push(key);
      }
    }
    return newEmailNotifications;
  }

  save(user: User): void {
    const params = {
      _id: user._id,
      firstName: user.firstName,
      lastName: user.lastName,
      department: user.department,
      job: user.job,
      site: user.site,
      driveurl: user.driveurl,
      emailNotifications: this.generateEmailNotificationsArray()
    };
    this.userService.update(params)
      .subscribe({
        next: res => {
          this.toast.setMessage('Account settings saved!', 'success');
          this.auth.currentUser = user;
          this.getUser();
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
